import React, { useState } from 'react';
import { Modal, Form, Button, Alert, Row, Col, Spinner } from 'react-bootstrap';
import { FaTimes, FaPlus, FaReceipt, FaTools, FaGasPump, FaCar } from 'react-icons/fa';
import { addExpense } from '../../services/api';


// ✅ BACKEND İLE TAM UYUMLU EXPENSE TYPES
export const expenseTypes = [
    { value: 'bakim_hasar', label: 'Bakım & Hasar', icon: FaTools, color: 'text-red-600' },
    { value: 'yakit', label: 'Yakıt', icon: FaGasPump, color: 'text-green-600' },
    { value: 'temizlik_detay', label: 'Temizlik & Detay', icon: FaCar, color: 'text-cyan-600' },
    { value: 'muayene', label: 'Muayene', icon: FaCar, color: 'text-orange-600' },
    { value: 'park_otopark', label: 'Park & Otopark', icon: FaCar, color: 'text-gray-600' },
    { value: 'yol_masrafi', label: 'Yol Masrafı', icon: FaReceipt, color: 'text-indigo-600' },
    { value: 'yemek', label: 'Yemek', icon: FaReceipt, color: 'text-pink-600' },
    { value: 'diger', label: 'Diğer', icon: FaReceipt, color: 'text-gray-600' }
];

const VehicleExpenseForm = ({ vehicleId, isOpen, onClose, onExpenseAdded }) => {
    const [formData, setFormData] = useState({
        type: '',
        description: '',
        amount: '',
        date: new Date().toISOString().split('T')[0],
        vendor: '',
        receiptNumber: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
    };

    // ✅ FIX: Form submit - parent'a masraf verisini gönder + DEBUG
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validasyon
        if (!formData.type || !formData.description || !formData.amount) {
            setError('Tür, açıklama ve tutar alanları zorunludur');
            return;
        }

        if (parseFloat(formData.amount) <= 0) {
            setError('Tutar sıfırdan büyük olmalıdır');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const expenseData = {
                ...formData,
                amount: parseFloat(formData.amount)
            };

            // ✅ FIX: AddVehiclePage için özel davranış + DEBUG
            if (vehicleId === 'temp') {
                // AddVehiclePage'deyiz - sadece parent'a veri gönder, API çağrısı yapma
                console.log('💰 AddVehiclePage masraf verisi hazırlanıyor:', expenseData);

                if (onExpenseAdded) {
                    console.log('💰 Calling onExpenseAdded with:', expenseData);
                    onExpenseAdded(expenseData); // ✅ Masraf verisini parametre olarak gönder
                } else {
                    console.error('❌ onExpenseAdded callback not found!');
                }
            } else {
                // Normal vehicle detay sayfasındayız - API çağrısı yap
                await addExpense(vehicleId, expenseData);

                if (onExpenseAdded) {
                    onExpenseAdded(); // Callback sadece refresh için
                }
            }

            // Form'u temizle
            setFormData({
                type: '',
                description: '',
                amount: '',
                date: new Date().toISOString().split('T')[0],
                vendor: '',
                receiptNumber: ''
            });

            console.log('✅ Masraf işlemi tamamlandı:', expenseData);
            onClose();
        } catch (error) {
            setError(error.response?.data?.message || 'Masraf eklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    // ✅ FIX: Modal kapanma - form'u temizle
    const handleClose = () => {
        setFormData({
            type: '',
            description: '',
            amount: '',
            date: new Date().toISOString().split('T')[0],
            vendor: '',
            receiptNumber: ''
        });
        setError('');
        onClose();
    };

    // 🔥 DEBUG: VehicleExpenseForm render kontrolü
    console.log('🔥 VehicleExpenseForm RENDER:', {
        isOpen,
        vehicleId,
        onClose: !!onClose,
        onExpenseAdded: !!onExpenseAdded
    });



    if (!isOpen) return null;
    console.log('🔥 VehicleExpenseForm MODAL RENDERING!');

    console.log('🔥 VehicleExpenseForm MODAL RENDERING!');

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaPlus className="me-2" />
                    Yeni Masraf Ekle
                    {vehicleId === 'temp' && (
                        <span className="ms-2 text-sm bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
                            Yeni Araç
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <Alert variant="danger">{error}</Alert>
                )}

                <Form onSubmit={handleSubmit}>
                    {/* Masraf Türü Seçimi - DROPDOWN */}
                    <Form.Group className="mb-3">
                        <Form.Label>Masraf Türü *</Form.Label>
                        <Form.Select
                            name="type"
                            value={formData.type}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Masraf türü seçin</option>
                            {expenseTypes.map(type => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Row>
                        {/* Açıklama */}
                        <Col md={8}>
                            <Form.Group className="mb-3">
                                <Form.Label>Açıklama *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    placeholder="Masraf açıklaması..."
                                    required
                                />
                            </Form.Group>
                        </Col>

                        {/* Tutar */}
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tutar (₺) *</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    placeholder="0.00"
                                    step="0.01"
                                    min="0"
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        {/* Tarih */}
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tarih</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </Col>

                        {/* Satıcı */}
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Satıcı/Firma</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="vendor"
                                    value={formData.vendor}
                                    onChange={handleInputChange}
                                    placeholder="Satıcı firma adı..."
                                />
                            </Form.Group>
                        </Col>

                        {/* Fiş No */}
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Fiş/Fatura No</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="receiptNumber"
                                    value={formData.receiptNumber}
                                    onChange={handleInputChange}
                                    placeholder="Fiş numarası..."
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    İptal
                </Button>
                <Button
                    variant="success"
                    onClick={handleSubmit}
                    disabled={loading || !formData.type || !formData.description || !formData.amount}
                >
                    {loading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Kaydediliyor...
                        </>
                    ) : (
                        <>
                            <FaPlus className="me-1" />
                            Masraf Ekle
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default VehicleExpenseForm;